import { PRIVATE_API } from './index';
export const submitReport = async ({ rallyId, taskId, category, description, language }) => {
    return PRIVATE_API.POST({
        endpoint: `/rallies/${rallyId}/report`,
        body: { taskId, category, description, language },
    });
};
